<template>
  <section class="bg-white px-5 py-4 md:py-5 md:rounded">
    <ai-summary-header :subtitle="$t('ai.summary.google')" :tooltip-text="$t('ai.google.notice')" />

    <google-ai-summary-card class="mt-3" :inner-class="cardInnerClass" @click="handleCardClick">
      <div ref="cardContentRef">
        <google-ai-summary-content :google-highlight="googleHighlight" :product-usp="productUsp" :vibe-service="vibeService" />
      </div>

      <div
        v-if="appStore.isMobileScreen && isOverflowing"
        class="absolute bottom-0 left-0 right-0 h-11 flex items-end justify-center bg-[linear-gradient(0deg,#ffffff_21.82%,rgba(255,255,255,0.31)_116.35%)]"
      >
        <svg-icon name="arrow-down" class="size-8 p-1.5 text-red-50" />
      </div>
    </google-ai-summary-card>

    <bottom-drawer v-model:visible="isDrawerOpen" :with-trigger-btn="false">
      <div class="full-height px-5 py-4 flex flex-col gap-4">
        <ai-summary-header :subtitle="$t('ai.summary.google')" :tooltip-text="$t('ai.google.notice')" />

        <google-ai-summary-card inner-class="p-4">
          <google-ai-summary-content :google-highlight="googleHighlight" :product-usp="productUsp" :vibe-service="vibeService" />
        </google-ai-summary-card>
      </div>
    </bottom-drawer>
  </section>
</template>

<script setup lang="ts">
import type { BranchReviewSummaryItem, BranchReviewHighlightItem } from '@/types/api'
import { useAppStore } from '@/store/app'

import BottomDrawer from '@/components/common/bottom-drawer.vue'
import GoogleAiSummaryCard from '@/components/product/product-detail/product-google-ai-summary-card.vue'
import GoogleAiSummaryContent from '@/components/product/product-detail/product-google-ai-summary-content.vue'
import AiSummaryHeader from '@/components/product/product-detail/product-ai-summary-header.vue'

// 168px 卡片高度上限，扣除 pt-4(16px)，content 閾值為 152px
const MOBILE_MAX_HEIGHT = 152

interface Props {
  summaries: BranchReviewSummaryItem[]
  highlights: BranchReviewHighlightItem[]
}

const props = defineProps<Props>()

const appStore = useAppStore()

const cardContentRef = ref<HTMLElement | null>(null)
const contentHeight = ref(0)
const isDrawerOpen = ref(false)

const productUsp = computed(() => props.summaries.find(s => s.type === 'product_usp'))
const vibeService = computed(() => props.summaries.find(s => s.type === 'vibe_service'))
const googleHighlight = computed(() => props.highlights[0])

const isOverflowing = computed(() => contentHeight.value > MOBILE_MAX_HEIGHT)

const cardInnerClass = computed(() =>
  appStore.isMobileScreen && isOverflowing.value
    ? 'px-4 pt-4 relative max-h-[168px] overflow-hidden cursor-pointer'
    : 'px-4 pt-4 relative pb-3 md:pb-4'
)

useResizeObserver(cardContentRef, ([entry]) => {
  contentHeight.value = entry.contentRect.height
})

function handleCardClick() {
  if (appStore.isMobileScreen && isOverflowing.value) isDrawerOpen.value = true
}
</script>
